import {ButtonBase, ButtonColors, ConcreteButtonProps} from "./button-base";
import React from "react";
import {observer} from "mobx-react-lite";
import {useServices} from "../../hooks/use-services.hook";


interface PrimaryShadeButtonInvertedProps extends ConcreteButtonProps {
}

export const PrimaryShadeButtonInverted: React.FC<PrimaryShadeButtonInvertedProps> = observer((props) => {
    const services = useServices();
    const themeColors = services.theme.currentTheme.colors;

    const buttonColors: ButtonColors = {
        $background: themeColors.light,
        $color: themeColors.primaryShade,
        $border: themeColors.primaryShade,
        $backgroundActivated: themeColors.primaryShade,
        $colorActivated: themeColors.light,
        $borderActivated: themeColors.primaryShade
    }
    return (
        <ButtonBase {...props} colors={buttonColors}>
            {props.children}
        </ButtonBase>
    );
});
